<template>
  <div class="uploaddata">
    <div class="content">
      <p>提示：单个照片容量上限10MB,视频上传容量上限30MB</p>
      <el-form label-position="top" :rules="rules" ref="ruleForm" label-width="80px" inlineMessage status-icon :model="formCase">
        <el-form-item label="经销店名称" prop="dealerName">
          <el-input disabled v-model="formCase.dealerName"></el-input>
          <!-- <el-select v-model="formCase.dealerName" placeholder="请选择" v-if="formCase.type == 1">
            <el-option
              v-for="item in caseTypeOption"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select> -->
        </el-form-item>
        <div class="qrcode">
          <img src="./soama.png" @click="sao" style="margin-right: 20px;" width="80" height="80" alt="">
        </div>
        <el-form-item label="服务委托书编号" prop="caseNo">
          <el-input v-model="formCase.caseNo"></el-input>
        </el-form-item>
        <el-form-item label="VIN" prop="vin">
          <el-input v-model="formCase.vin" @blur="getBlur()">
            <!-- <el-button slot="append" icon="el-icon-search" @click.native="searchs"></el-button> -->
          </el-input>
        </el-form-item>
        <div  v-if="formCase.attaGroup">
        <div class="" v-for="it in Object.keys(formCase.attaGroup)" v-if="users.name!==it">
          <el-form-item label="" prop="title">
            <span style="margin-right: 20px; width: 100px;float: left;">{{it}}</span>
            <!-- <el-button type="primary" size="mini" @click="confirmUserFn(it)">全部承认</el-button> -->
          </el-form-item>
          <el-row class="row-bg">
            <el-col :span="10" style="margin-right: 6%;position:relative" v-for="(item, index) in formCase.attaGroup[it]" :key="index">
              <img :src="item.url" preview="2" style="width: 100%" alt="" class="picture" v-if="item.type&&item.type.indexOf('image')>=0">
              <!-- <video :src="item.url" preload="auto" x5-playsinline style="width: 150px;height:150px;posiiton:relative;z-index:99999;"  x-webkit-airplay="true" x5-video-player-type="h5" x5-video-player-fullscreen="true" v-if="item.type&&item.type.indexOf('video')>=0"  webkit-playsinline="true" playsinline="true" controls></video> -->
              <el-row style="height:180px; width:100%;" v-else-if="item.type&&item.type.indexOf('video')>=0">
                <div style="position:absolute;height:160px;width:100%;" >
                  <video :src="item.url" style="width: 100%;object-fit:fill;height: 100%;" controls="controls" preload="auto" x5-video-player-fullscreen="true" webkit-playsinline="true" x-webkit-airplay="true" playsinline="true" x5-playsinline></video>
                  <a style="position:relative;top:0;right:-100px;z-index:999;" :href="item.url" download>下载</a>
                </div>
              </el-row>
              <div style="width:100%;height:100%;" v-else><i class="el-icon-document" style="color:#000;font-size:80px;text-align:center;line-height:148px;width:100%;float:left"></i><a :href="'api/'+item.url" style="position:absolute;width:100%;height:100%;top:0;left:0" alt="" download></a></div>

              <div v-if="item.dtrStatus==='被打回'">
                附件状态： 退回
              </div>
            </el-col>
          </el-row>
        </div>
        </div>
        <el-form-item label="附件(图片)" v-if="formCase.status!=='通过'&&formCase.status!=='已提交'">
          <Upload url="api/file/Upload" :flag="flags" type="image" :caseNo="formCase.caseNo" :attac="formCase.attachmentIds" :fileList="fileList.filter(item=> item.type&&item.type.indexOf('image')>=0)" @sub1="subs" @changeAttach="changeAttachs"></Upload>
        </el-form-item>
        <el-form-item label="附件(视频)" v-if="formCase.status!=='通过'&&formCase.status!=='已提交'">
          <Upload url="api/file/Upload" :flag="flags" type="video" :caseNo="formCase.caseNo" :attac="formCase.attachmentIds" :fileList="fileList.filter(item=> item.type&&item.type.indexOf('video')>=0)" @sub1="subs" @changeAttach="changeAttachs"></Upload>
        </el-form-item>
        <!-- <el-form-item style="text-align: center" v-if="users.dlrAdvanceUser"> -->
        <el-form-item style="text-align: center">
          <el-button type="info" @click.native="cancels">取消</el-button>
          <el-button type="primary" @click.native="submitFn" :disabled="disabled">提交审批</el-button>
          <el-button type="primary" @click.native="onSave1">保存草稿</el-button>
          <!-- <el-button type="success" @click.native="onSave">保存</el-button> -->
          <!-- <el-button type="danger" @click.native="onDelete">删除</el-button> -->
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script type="text/javascript">
import Upload from './Upload'
//import wx from "weixin-jsapi"
import axios from '@/utils/api.request'
import { Toast, MessageBox } from 'mint-ui'
import { getImg } from '@/api/case.js'
import { getDetailData, saveDraft, submitCase, getCaseItem, saveDraft1, submitCase1 } from '@/api/quality'
import Global from '@/config/global.js'
export default{
  components: { Upload },
  data() {
    return {
      rules: {
        vin: [
          { required: true, message: '该项不能为空', trigger: 'change' },
          { min: 17,max:17, message: 'VIN码应为17位' }
        ],
        caseNo: [{ required: true, message: '该项不能为空', trigger: 'change' }]
      },
      formCase: {},
      fileList: [],
      attachmentIdss: [],
      sub: false,
      ticketNum: '',
      users: {},
      vin: '',
      disabled: true,
      flags: false
    }
  },
  created() {
    //this.getDetail()
    if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        this.flags = true
    } else {
       this.flags = false
    }
    this.users = JSON.parse(localStorage.getItem("user"))
    this.formCase.attachmentIds = this.formCase.attachmentIds?this.formCase.attachmentIds:[]
    if(this.$route.params.id>0){

      getCaseItem(this.$route.params.id).then(res => {
        this.formCase = res.data.data
        if(this.formCase.vin&&this.formCase.vin.length===17){
          this.disabled = false
        }
        if(this.formCase.attaGroup&&Object.keys(this.formCase.attaGroup)){
          let groupList = Object.keys(this.formCase.attaGroup)
          groupList.forEach((it) => {
            let arr = []
            this.formCase.attaGroup[it].forEach((v, i) => {
              let json = {
                id: v.id,
                name: v.rawName,
                url: v.url,
                type: v.mime,
                dtrStatus: v.dtrStatus
              }
              arr.push(json)
              if(v.mime.indexOf('image')>=0){
                getImg(v.url).then(resp=>{
                  var mimeType = v.mime.toLowerCase();
                  var imgBase64 = new Buffer(resp.data, 'binary').toString('base64');
                  arr[i].url = 'data:' + mimeType + ';base64,' + imgBase64;
                })
              }else if(v.mime.indexOf('video')>=0){
                 arr[i].url = Global.server_api + v.url;
              }

            })
            this.formCase.attaGroup[it] = arr
          })

        }
        if(this.formCase.attaList){
          this.formCase.attaList.forEach((v, i) => {
            let json = {
              id: v.id,
              name: v.rawName,
              url: v.url,
              type: v.mime,
              dtrStatus: v.dtrStatus
            }
            this.fileList.push(json)
            if(v.mime.indexOf('image')>=0){
              getImg(v.url).then(resp=>{
                var mimeType = v.mime.toLowerCase();
                var imgBase64 = new Buffer(resp.data, 'binary').toString('base64');
                this.fileList[i].url = 'data:' + mimeType + ';base64,' + imgBase64;
              })
            }else if(v.mime.indexOf('video')>=0){
               this.fileList[i].url = Global.server_api + v.url;
            }

          })
        }
      })
    }
  },
  methods: {
    cancels() {
      this.$router.go(-1);
    },
    submitFn() {
      if(this.formCase.caseNo){
        submitCase1(this.formCase.caseNo).then(res => {
          if(res.data.success){
            Toast({
                message: res.data.msg,
                iconClass: 'icon el-icon-check'
              });
              this.$router.push('/quality')
            }else{
              Toast({
                message: res.data.msg,
                iconClass: 'icon el-icon-close'
              });
            }
        })
      }

    },
    onSubmit() {
      this.$on('changeAttachs',data => {
        console.log(data)
        this.attachmentIdss = data
      })
      //this.changeAttachs()
      this.$refs.ruleForm.validate((valid) => {
        if(valid){
          MessageBox.confirm('',{
            title: '提示',
            message: '提交后无法撤回，确认提交?',
            showCancelButton: true
          }).then(() => {
            console.log(this.formCase)
            this.formCase.attachmentIds = []
            if(this.attachmentIdss){
              this.attachmentIdss.forEach((v, i) => {
                this.formCase.attachmentIds.push(v.id)
              })
            }
            submitCase({caseNo:this.formCase.caseNo, vin: this.formCase.vin}).then((res)=>{
              if(res.data.success){
                Toast({
                  message: res.data.msg,
                  iconClass: 'icon el-icon-check'
                });
                this.$router.push('/quality')
              }else{
                Toast({
                  message: res.data.msg,
                  iconClass: 'icon el-icon-close'
                });
              }
            })
            this.sub = true
            setTimeout(() => {
              this.sub = false
            }, 3000)
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消提交'
            });
          });
        }
      })
    },
    onSave1() {
      if(!this.formCase.caseNo){
        Toast({
          message: '无案件',
          iconClass: 'icon el-icon-close'
        });
        return
      }
      this.$on('changeAttachs',data => {
        console.log(data)
        this.attachmentIdss = data
      })
      this.formCase.attachmentIds = []
      this.attachmentIdss.forEach((v, i) => {
        this.formCase.attachmentIds.push(v.id)
      })

      saveDraft1(this.formCase.caseNo).then(res => {
        if(res.data.success){
          Toast({
            message: res.data.msg,
            iconClass: 'icon el-icon-check'
          });
          this.$router.push('/quality')
        }else{
          Toast({
            message: res.data.msg,
            iconClass: 'icon el-icon-close'
          });
        }
      })
    },
    onSave() {
      this.$on('changeAttachs',data => {
        console.log(data)
        this.attachmentIdss = data
      })
      this.formCase.attachmentIds = []
      this.attachmentIdss.forEach((v, i) => {
        this.formCase.attachmentIds.push(v.id)
      })
      if(this.formCase.id>0){
        updateCase(this.formCase.id, this.formCase).then(res => {
            if(res.data.success){
              Toast({
                message: res.data.msg,
                iconClass: 'icon el-icon-check'
              });
              this.$router.push('/case')
            }else{
              Toast({
                message: res.data.msg,
                iconClass: 'icon el-icon-close'
              });
            }
        })
      }else{
        console.log(this.formCase)
        saveDraft(this.formCase).then(res => {
            console.log(res)
          if(res.data.success){
            this.formCase.id = res.data.data.id
            Toast({
              message: res.data.msg,
              iconClass: 'icon el-icon-check',
              duration: 2000
            });
            setTimeout( () =>{
              this.$router.push('/quality')
            },2000)
          }else{
            Toast({
              message: res.msg,
              iconClass: 'icon el-icon-close'
            });
          }
        })
      }
    },
    onDelete() {
      delete0(this.formCase.id).then(res => {
        Toast({
          message: '删除成功',
          position: 'top',
        });
        this.$router.push('/quality')
      })
    },
    sao() {
      let _this = this
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"],
        success(res) {
          var result = res.resultStr  // 当needResult 为1时，扫码返回结果
          _this.ticketNum = res.resultStr.split('-')[0]
          _this.vin = res.resultStr.split('-')[1]
          //alert(JSON.stringify(res))
          //_this.$router.push(`/qualityDetail/${_this.ticketNum}/${_this.vin}`)
          //_this.$router.push(`/pendingApproval/${_this.ticketNum}/${_this.vin}`)

          _this.getDetail()
          Toast({
            message: '扫码成功caseNo:'+_this.ticketNum+',vin:'+_this.vin,
            iconClass: 'icon el-icon-check'
          })

        }
      })
    },
    getDetail() {
      this.disabled = false
      getDetailData({caseNo:this.ticketNum, vin:this.vin}).then(res => {
        if(res.data.success){
          this.formCase = res.data.data
          if(this.formCase.attaGroup&&Object.keys(this.formCase.attaGroup)){
            let groupList = Object.keys(this.formCase.attaGroup)
            groupList.forEach((it) => {
              let arr = []
              this.formCase.attaGroup[it].forEach((v, i) => {
                let json = {
                  id: v.id,
                  name: v.rawName,
                  url: v.url,
                  type: v.mime,
                  dtrStatus: v.dtrStatus
                }
                arr.push(json)
                if(v.mime.indexOf('image')>=0){
                  getImg(v.url).then(resp=>{
                    var mimeType = v.mime.toLowerCase();
                    var imgBase64 = new Buffer(resp.data, 'binary').toString('base64');
                    arr[i].url = 'data:' + mimeType + ';base64,' + imgBase64;
                  })
                }else if(v.mime.indexOf('video')>=0){
                   arr[i].url = Global.server_api + v.url;
                }

              })
              this.formCase.attaGroup[it] = arr
            })

          }
          if(this.formCase.attaList){
            this.formCase.attaList.forEach((v, i) => {
              let json = {
                id: v.id,
                name: v.rawName,
                url: v.url,
                type: v.mime
              }
              this.fileList.push(json)
              if(v.mime.indexOf('image')>=0){
                getImg(v.url).then(resp=>{
                  var mimeType = v.mime.toLowerCase();
                  var imgBase64 = new Buffer(resp.data, 'binary').toString('base64');
                  this.fileList[i].url = 'data:' + mimeType + ';base64,' + imgBase64;
                })
              }else if(v.mime.indexOf('video')>=0){

                 this.fileList[i].url = Global.server_api + v.url;

                // getVideo(v.url).then(resp=>{
                //   this.fileList[i].url = URL.createObjectURL(resp.data)

                // })
              }

            })
          }
          Toast({
            message: '获取案件成功',
            iconClass: 'icon el-icon-check'
          })
        }else{
          // this.$message({
          //   type: 'error',
          //   message: res.data.msg
          // })
          Toast({
            message: res.data.msg,
            iconClass: 'icon el-icon-close'
          })
        }
      })
    },
    getBlur() {
      if(this.formCase.vin&&this.formCase.vin.length===17){
        this.disabled = false
        this.getDetail1()
      }else{
        this.disabled = true
      }
    },
    getDetail1() {
      if(!this.ticketNum&&this.formCase.vin.length===17){
        this.disabled = false
        getDetailData({caseNo:this.formCase.caseNo, vin:this.formCase.vin}).then(res => {
          if(res.data.success){
            this.formCase = res.data.data
            if(this.formCase.attaGroup&&Object.keys(this.formCase.attaGroup)){
              let groupList = Object.keys(this.formCase.attaGroup)
              groupList.forEach((it) => {
                let arr = []
                this.formCase.attaGroup[it].forEach((v, i) => {
                  let json = {
                    id: v.id,
                    name: v.rawName,
                    url: v.url,
                    type: v.mime,
                    dtrStatus: v.dtrStatus
                  }
                  arr.push(json)
                  if(v.mime.indexOf('image')>=0){
                    getImg(v.url).then(resp=>{
                      var mimeType = v.mime.toLowerCase();
                      var imgBase64 = new Buffer(resp.data, 'binary').toString('base64');
                      arr[i].url = 'data:' + mimeType + ';base64,' + imgBase64;
                    })
                  }else if(v.mime.indexOf('video')>=0){
                     arr[i].url = Global.server_api + v.url;
                  }

                })
                this.formCase.attaGroup[it] = arr
              })

            }
            if(this.formCase.attaList){
              this.formCase.attaList.forEach((v, i) => {
                let json = {
                  id: v.id,
                  name: v.rawName,
                  url: v.url,
                  type: v.mime
                }
                this.fileList.push(json)
                if(v.mime.indexOf('image')>=0){
                  getImg(v.url).then(resp=>{
                    var mimeType = v.mime.toLowerCase();
                    var imgBase64 = new Buffer(resp.data, 'binary').toString('base64');
                    this.fileList[i].url = 'data:' + mimeType + ';base64,' + imgBase64;
                  })
                }else if(v.mime.indexOf('video')>=0){

                   this.fileList[i].url = Global.server_api + v.url;

                  // getVideo(v.url).then(resp=>{
                  //   this.fileList[i].url = URL.createObjectURL(resp.data)

                  // })
                }

              })
            }
            Toast({
              message: '获取案件成功',
              iconClass: 'icon el-icon-check'
            })
          }else{
            // this.$message({
            //   type: 'error',
            //   message: res.data.msg
            // })
            Toast({
              message: res.data.msg,
              iconClass: 'icon el-icon-close'
            })
          }
        })
      }else{
        this.disabled = true
      }
    },
    subs(data) {
      console.log('111',data)
      this.sub = data
    },
    changeAttachs(data) {
        console.log(data)
      this.attachmentIdss = data;
    },
    getSign() {
      let _url = location.href.split('#')[0]

      // let _url = ''
      // if (window.__wxjs_is_wkwebview === true) {
      //   _url = window.location.href.split('#')[0] || window.location.href
      // } else {
      //   _url = window.location.href
      // }
      axios.request({
        url: `/api/jsapisign`,
        method: 'post',
        data: {clientUrl: _url,customizeUrl: _url, url: _url}
      }).then(res => {
        // wx.config({
        //   debug: true, // 开启调试模式，调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开
        //   appId: res.data.corpid, // 必填， 公众号的唯一标识
        //   timestamp: res.data.timestamp, // 必填，生成签名的时间戳
        //   nonceStr: res.data.nonceStr, // 必填， 生成签名的随机串
        //   signature: res.data.signature, // 必填，签名
        //   jsApiList: ["scanQRCode"] // 必填，需要使用的JS接口列表
        // })
        wx.config({
          // debug: true, // 开启调试模式，调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开
          // appId: res.data.corpid, // 必填， 公众号的唯一标识
          // timestamp: '1605369404', // 必填，生成签名的时间戳
          // nonceStr: '1b7d09fa-0f29-4b91-876a-f6f3b809701f', // 必填， 生成签名的随机串
          // signature: '8e632b545595bfade3781bbdf42e0750d75361c1', // 必填，签名
          // jsApiList: ["scanQRCode"] // 必填，需要使用的JS接口列表
          beta: true,// 必须这么写，否则wx.invoke调用形式的jsapi会有问题
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: res.data.corpid, // 必填，企业微信的corpID
          timestamp:  res.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
          signature: res.data.signature,// 必填，签名，见附录1
          jsApiList: ["chooseImage", "invoke"] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        })
        wx.ready(function () {
          wx.checkJsApi({
            jsApiList: ["invoke", "scanQRCode"], // 需要检测的JS接口列表，所有JS接口列表见附录2,
            success: function (ress) {
              // 以键值对的形式返回，可用的api值true，不可用为false
              // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
            }
          });
        })
        // wx.ready(() => {
        //   let _this = this
        //   wx.scanQRCode({
        //     needResult: 0, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        //     scanType: ["qrCode", "barCode"],
        //     success(res) {
        //       var result = res.resultStr  // 当needResult 为1时，扫码返回结果
        //       _this.ticketNum = res.resultStr
        //     }
        //   })
        // })
        wx.error((res) => {
          console.log(res)
        })
      })

    },
  },
  mounted() {
    this.getSign()
  }
}
</script>

<style scoped>
.uploaddata{
  background: #fff;
  text-align: left;
  padding: 0.3rem;

}
</style>
